import React from 'react';

import { confirm } from './index';
import editorActions from '../../../actions/editorActions';


// eslint-disable-next-line default-param-last
export default function closeCatalogEditConfirmation({ message, callback, confirmProps = {}, t }) {
  const messageParts = message.split("/");
  const sectionId = messageParts[0];
  const catalogId = messageParts[1];

  const { text, headerText, saveText, abortText, cancelText } = confirmProps;

  function onSave(closeCallback) {
    editorActions.validateAndSaveCatalog(
      sectionId,
      (result) => {
        closeCallback && closeCallback();
        callback && callback(true);
      },
      (error) => {
        closeCallback && closeCallback();
        onCancel();
      },
    )
  }

  function onAbort() {
    callback && callback(true);
  }

  function onCancel() {
    callback && callback(false);
  }



  confirm({
    onSave,
    onAbort,
    onCancel,
    headerText: headerText || t('modals.closeCatalogEditor.headerText'),
    text: (
      <span
        dangerouslySetInnerHTML={{
          __html: text || t('modals.closeCatalogEditor.text'),
        }}
      />
    ),
    saveText: saveText !== undefined ? saveText : t('modals.closeCatalogEditor.saveText'),
    abortText: abortText !== undefined ? abortText : t('modals.closeCatalogEditor.abortText'),
    cancelText: cancelText !== undefined ? cancelText : t('modals.closeCatalogEditor.cancelText'),
  });
}
